export enum OsVersionSoletenant {
    W10E = 'Windows 10 Enterprise',
    W7E = 'Windows 7 Enterprise',
    WS2019 = 'Windows Server 2019',
    WS2016= 'Windows Server 2016'
 }


